import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var XpResource = function (props) {
    return (React.createElement("div", { className: "flex flex--aligned flex--stacked" },
        React.createElement(Icon, { icon: IdIcon.XpIcn, tooltipLoca: IdLoca.tooltip_playerXp_web, styleId: IdStyles.IconLarge }),
        React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
            React.createElement(NumberFormat, { amount: props.xpType.amount }),
            React.createElement(NumberFormat, { amount: props.xpBuffAmount || Long.ZERO, format: TypeNumberFormat.AddExceptZero }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/XpResource.tsx
// module id = 2257
// module chunks = 3